import Player from './player'

function loadPlayer() {
  const player = new Player(window.PLAYER_METADATA)
  const photo = player.get('twitter_photo')
  if ( photo ) {
    const imageUrl = photo.replace(/_normal\.jp/, '_200x200.jp')
    const downloadingImage = new Image()
    const profileImage = document.querySelector('.js-player-twitter-photo')
    
    downloadingImage.onload = function(e) {
      profileImage.src = imageUrl
      profileImage.alt = `${player.name}'s twitter avatar`
    }

    downloadingImage.onerror = function(e) {
      profileImage.src = profileImage.dataset.fallbackImage
    }
    
    downloadingImage.src = imageUrl
  }
}

if ( document.readyState === 'loading' ) {
  document.addEventListener('DOMContentLoaded', loadPlayer)
} else {
  loadPlayer()
}



// WEBPACK FOOTER //
// ./app/javascript/player/index.js